import { useQuery } from '@tanstack/react-query';
import { getIslandsList } from '../api/islandsApi';
import { Island } from '../api/islandsApi/interfaces';

export const useGetIslandsList = (enabled: boolean = true) => {
  return useQuery<Island[]>({
    queryFn: () => getIslandsList(),
    queryKey: ['islands-list'],
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled,
  });
};
